import cocopkg from '../package.json'

let env = 'production';

const config = {
  env: env == 'dev' ?
  {
    // server:'//localhost:7989',
    // login:'//localhost:3001/login',
    server:'//cocorobo.hk/api',
    login:'//staging.cocorobo.hk/login',
    version: cocopkg.version
  }
  :{
    server:'//api.cocorobo.hk',
    login:'//cocorobo.hk/login',
    version: cocopkg.version
  }
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js